import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PartialMedia, PartialMediaWithId } from "../types/media";
import { updateMedia } from "../services/medias.service";
import { QueryKeys } from "./queryKeys";

export const useUpdateMedia = (mediaId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PartialMedia) => updateMedia(mediaId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.Media],
      });
    },
  });
};

export const useUpdateMediaWithId = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (partialMedia: PartialMediaWithId) =>
      updateMedia(partialMedia.id, partialMedia),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.Media],
      });
    },
  });
};
